import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";
import * as resolvType from "../../utils/resolveType.js";

const Stangenfilter = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);
  let resolvedValue = value.value;

  // Bit auflösen
  if (props.element.bit !== undefined) {
    resolvedValue = resolvType.readBit(
      value.value,
      props.element.bit,
      value.type,
    );
  }

  //========================================================================
  // Index als Wert aus globalVars
  let idx = Math.abs(parseInt(resolvedValue));

  //========================================================================
  // Simulation
  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    idx = Math.abs(parseInt(simValue));
  }

  //========================================================================
  // Bilder laden
  const pathPos0 = require("../../images/controls/Stangenfilter/StangenfilterPos0.png");
  const pathPos1 = require("../../images/controls/Stangenfilter/StangenfilterPos1.png");

  let imagePath = pathPos0;
  if (isFinite(idx)) {
    switch (idx) {
      case 0:
        imagePath = pathPos0;
        break;
      case 1:
        imagePath = pathPos1;
        break;
    }
  }

  return (
    <img
      style={{
        ...props.style,
        visibility: props.props.visibility,
      }}
      title={
        language.displayText(value.name) +
        (globalVars.cyclicUpdate || globalVars.editor
          ? "\n" + ("Variable: " + props.props.variable)
          : "")
      }
      src={imagePath}
    />
  );
});

export default Stangenfilter;
